<template>
  <v-app
    id="inspire"
    :class="{'is-admin': without_toolbar && mixin_isGodMode}"
    :data-content="mixin_isGodMode ? $t('Common.Admin') : ''">
    <Snow v-if="needSnow"/>
    <LayoutMenu
      v-if="!without_toolbar"/>
    <v-main
      class="px-0"
      :class="{with_toolbar : !without_toolbar}">
      <BannerSignalReconnect/>
      <router-view/>
      <FeedbackButton/>
      <UpPutton/>
    </v-main>
    <ActionsToolbar/>
    <TemplateSnackbar/>
    <NewReleaseDialog
      v-if="!!releaseSettings"
      :release-settings="releaseSettings"/>
    <LowBalanceDialog
      v-show="showLowBalanceDialog"
      :show.sync="showLowBalanceDialog"/>
    <Overlay
      v-if="showOverlay"/>
    <ExitConfirmation/>
    <DownloadFiles/>
    <OldCabinetModal v-if="modalNewCabinet"/>
    <ModalDocumentView
      v-if="showDocument"
      :document.sync="showDocument"/>
  </v-app>
</template>
<script>
import Snow from 'components/layout/Snow.vue'
import Overlay from 'components/layout/Overlay.vue'
import LayoutMenu from 'components/header/LayoutMenu.vue'
import UpPutton from 'components/common/elements/UpBtn.vue'
import DownloadFiles from 'components/layout/DownloadFiles.vue'
import ActionsToolbar from 'components/layout/ActionsToolbar.vue'
import FeedbackButton from 'components/feedback/FeedbackButton.vue'
import OldCabinetModal from 'components/layout/OldCabinetDialog.vue'
import TemplateSnackbar from 'components/layout/TemplateSnackbar.vue'
import ExitConfirmation from 'components/layout/ExitConfirmation.vue'
import LowBalanceDialog from 'components/billing/LowBalanceDialog.vue'
import NewReleaseDialog from 'components/releases/NewReleaseDialog.vue'
import ModalDocumentView from 'components/layout/ModalDocumentView.vue'
import BannerSignalReconnect from 'components/layout/BannerSignalReconnect.vue'

import SmarttenderApi from '@/api/smarttenderApi'
const api = new SmarttenderApi()
import moment from 'moment'
import { userMixin } from 'mixins'
import tour from 'mixins/tour'
import theme from 'mixins/theme'
import errorTooltip from 'mixins/errorTooltip'
import { storageMixin } from 'mixins'
import godModeMixin from 'mixins/godModeMixin'

import { mapGetters } from 'vuex'

export default {
  name: 'layout',
  mixins: [tour, userMixin, storageMixin, theme, godModeMixin, errorTooltip],
  data() {
    return {
      needSnow: false,
      modalNewCabinet: false,

      releaseSettings: null,
      showOverlay: false,
      typeOverlay: null,
      showDocument: null,
    }
  },
  created () {
    let at = this.$t('Common.at')
    moment.updateLocale( sessionStorage.language, {
      calendar: {
        lastWeek: 'dddd ' + '[' + at + ']' + ' HH:mm',
        sameElse: function () {
          if (this.isSame( moment(), 'year') ) {
            return 'DD MMMM ' + '[' + at + ']' + ' HH:mm'
          } else {
            return 'DD MMMM YYYY ' + '[' + at + ']' + ' HH:mm'
          }
        }
      }
    })
    this.$acl.onChange = newPermission => {
      this.$log(this.$acl.get, 'has changed to', newPermission, this.$route.meta?.rule)
      if ( this.$acl.not.check(this.$route.meta?.rule) && newPermission != this.$acl.get[0] ) {
        this.$log('page-error')
        this.$router.push({name: 'page-error', params: { status_code: 403, descript: 'Layout empty rule'}})
      }
    }

    let query_org = this.$route.query?.organization
    let orgId = this.$route.params.org || query_org || this.storedCurrentOrganization.organizationItId
    let current = this.$store.getters.getCurrentOrganization
    if (orgId) {
      let avOrgs = this.$store.getters.getAvailableOrganizations
      let newOrg = this.$_?.find( avOrgs , ['organizationItId', +orgId] )
      if (!newOrg) {
        return this.$router.push({name: 'page-error', params: { status_code: 403, descript: 'newOrg empty'}})
      }
      this.changeOrganisation( newOrg , current )
      // this.$router.replace('')
      if ( query_org ) {
        this.$router.replace('')
      }
    } else if ( this.$route.meta.needOrg ) {
      this.$router.replace({
        name: this.$route.name,
        query: this.$route.query,
        params: {...this.$route.params, org: current?.organizationItId}})
    }
  },
  methods: {
    changeSnow() {
      this.needSnow = !this.needSnow
      this.$_savePropToLocalStorage('show-snow', this.needSnow)
    },
    setSubscriptions(items) {
      this.$store.dispatch('notification/setSubscriptions', {items})
    },
    setLastEvent(items) {
      this.$store.dispatch('notification/setLastEvent', items)
    },
    updateEventSubscription(data) {
      this.setSubscriptions([ data ])
    },
    updateEventsStatuses(items) {
      this.$store.dispatch('notification/changeState', items)
    },
    onShowOverlay(name) {
      this.showOverlay = true
      this.typeOverlay = name
      if (name == 'changeOrganisation') {
        this.$store.commit('changeOrganisation', true)
      }
    },
    onCloseOverlay() {
      this.showOverlay = false
      if (this.typeOverlay == 'changeOrganisation') {
        this.$store.commit('changeOrganisation', false)
      }
    },
    showDocumentView(attachment) {
      this.showDocument = attachment
    },
  },
  mounted() {
    const localSnow = this.$_getPropFromLocalStorage('show-snow', true)
    const date = new Date()
    this.needSnow = localSnow && (date.getMonth() === 11 && date.getDate() >= 15 || date.getMonth() === 0 && date.getDate() <= 15)

    this.$root.$on('changeSnow', this.changeSnow)
    this.$root.$on('UpdateSubscriptions', this.setSubscriptions)
    this.$root.$on('SetLastEvent', this.setLastEvent)
    this.$root.$on('UpdateEventSubscription', this.updateEventSubscription)
    this.$root.$on('UpdateEventsStatuses', this.updateEventsStatuses)

    this.$root.$on('showOverlay', this.onShowOverlay)
    this.$root.$on('closeOverlay', this.onCloseOverlay)

    this.$root.$on('showDocumentView', this.showDocumentView)

    this.modalNewCabinet = this.$can('set', 'redirectToOldCabinetMethodAccessibility') && (this.user.redirectToOldCabinetCount || 0) < 3
    if (this.modalNewCabinet) {
      api.enterTheCabinet()
    } else {
      this.$store.dispatch('getReleasesSettings')
        .then( releaseSettings => {
          if (releaseSettings?.features?.length &&  this.$acl.not.check('noAccess') ) {
            const capitalizeFirstLetter = (string) => {
              return string.charAt(0).toUpperCase() + string.slice(1)
            }
            releaseSettings?.features.forEach(feature => {
              feature.name = capitalizeFirstLetter(feature.name)
              feature.nameEng = capitalizeFirstLetter(feature.nameEng)
            })
            this.releaseSettings = releaseSettings
          }
        })
    }
    this.checkAccess()
    let that = this
    this.$nextTick(() => that.$store.dispatch('configureSatismeter', this.$route.name))
  },
  computed: {
    ...mapGetters({
      storedCurrentOrganization: 'getCurrentOrganization'
    }),
    currentLocale() {
      return this.$i18n.locale
    },
    without_toolbar() {
      return this.$route.meta?.without_toolbar
    },
    user() {
      return this.$store.getters['GET_USER']
    },
  },
  beforeDestroy() {
    this.$root.$off('changeSnow', this.changeSnow)
    this.$root.$off('UpdateSubscriptions', this.setSubscriptions)
    this.$root.$off('SetLastEvent', this.setLastEvent)
    this.$root.$off('UpdateEventSubscription', this.updateEventSubscription)
    this.$root.$off('UpdateEventsStatuses', this.updateEventsStatuses)

    this.$root.$off('showOverlay', this.onShowOverlay)
    this.$root.$off('closeOverlay', this.onCloseOverlay)

    this.$root.$off('showDocumentView', this.showDocumentView)
  },
  components: {
    Snow,
    Overlay,
    UpPutton,
    LayoutMenu,
    DownloadFiles,
    FeedbackButton,
    ActionsToolbar,
    TemplateSnackbar,
    NewReleaseDialog,
    LowBalanceDialog,
    ExitConfirmation,
    OldCabinetModal,
    ModalDocumentView,
    BannerSignalReconnect,
  },
  watch: {
    'allDbStore': {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue['user-theme']) {
          this.setTheme(newValue['user-theme'])
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
div#inspire.is-admin:before {
  content: attr(data-content);
  position: fixed;
  top: 8px;
  left: -22px;
  color: white;
  width: 85px;
  z-index: 11;
  line-height: 1.25;
  transform: rotate(-45deg);
  background: var(--color-error);
}

.route-enter-active, .route-leave-active {
  transition: opacity .2s;
}
.route-enter, .route-leave-to
 {
  opacity: 0;
}
#inspire {
  max-width: 100%;
}
</style>
